import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarCommon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 122.88 121",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".common-calendar-icon-st1{fill:#ef4136;}.common-calendar-icon-st1,.common-calendar-icon-st3,.common-calendar-icon-st4,.common-calendar-icon-st6{fill-rule:evenodd;}.common-calendar-icon-st2{fill:gray;}.common-calendar-icon-st3{fill:#fff;}.common-calendar-icon-st4{fill:#c72b20;}.common-calendar-icon-st5,.common-calendar-icon-st6{fill:#1a1a1a;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "calendar-color" }),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st1",
			d: "M11.52,6.67h99.84a11.57,11.57,0,0,1,11.52,11.52V44.94H0V18.19A11.56,11.56,0,0,1,11.52,6.67Zm24.79,9.75A9.31,9.31,0,1,1,27,25.73a9.31,9.31,0,0,1,9.31-9.31Zm49.79,0a9.31,9.31,0,1,1-9.31,9.31,9.31,9.31,0,0,1,9.31-9.31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st2",
			d: "M111.36,121H11.52A11.57,11.57,0,0,1,0,109.48V40H122.88v69.46A11.56,11.56,0,0,1,111.36,121Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st3",
			d: "M12.75,117.31h97.38a9.1,9.1,0,0,0,9.06-9.06V40H3.69v68.23a9.09,9.09,0,0,0,9.06,9.06Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st4",
			d: "M86.1,14.63a11.11,11.11,0,1,1-7.85,3.26l.11-.1a11.06,11.06,0,0,1,7.74-3.16Zm0,1.79a9.31,9.31,0,1,1-9.31,9.31,9.31,9.31,0,0,1,9.31-9.31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st4",
			d: "M36.31,14.63a11.11,11.11,0,1,1-7.85,3.26l.11-.1a11.08,11.08,0,0,1,7.74-3.16Zm0,1.79A9.31,9.31,0,1,1,27,25.73a9.31,9.31,0,0,1,9.31-9.31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st5",
			d: "M80.54,4.56C80.54,2,83,0,86.1,0s5.56,2,5.56,4.56V25.77c0,2.51-2.48,4.56-5.56,4.56s-5.56-2-5.56-4.56V4.56Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st5",
			d: "M30.75,4.56C30.75,2,33.24,0,36.31,0s5.56,2,5.56,4.56V25.77c0,2.51-2.48,4.56-5.56,4.56s-5.56-2-5.56-4.56V4.56Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st6",
			d: "M22,85.62H36a1.79,1.79,0,0,1,1.79,1.79v11.7A1.8,1.8,0,0,1,36,100.9H22a1.8,1.8,0,0,1-1.8-1.79V87.41A1.8,1.8,0,0,1,22,85.62Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st6",
			d: "M54.58,85.62H68.64a1.79,1.79,0,0,1,1.79,1.79v11.7a1.8,1.8,0,0,1-1.79,1.79H54.58a1.8,1.8,0,0,1-1.79-1.79V87.41a1.8,1.8,0,0,1,1.79-1.79Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st6",
			d: "M86.87,85.62h14.06a1.8,1.8,0,0,1,1.79,1.79v11.7a1.8,1.8,0,0,1-1.79,1.79H86.87a1.8,1.8,0,0,1-1.79-1.79V87.41a1.79,1.79,0,0,1,1.79-1.79Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st6",
			d: "M22,56.42H36a1.8,1.8,0,0,1,1.79,1.8V69.91A1.8,1.8,0,0,1,36,71.7H22a1.8,1.8,0,0,1-1.8-1.79V58.22a1.81,1.81,0,0,1,1.8-1.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st6",
			d: "M54.58,56.42H68.64a1.8,1.8,0,0,1,1.79,1.8V69.91a1.8,1.8,0,0,1-1.79,1.79H54.58a1.79,1.79,0,0,1-1.79-1.79V58.22a1.8,1.8,0,0,1,1.79-1.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "common-calendar-icon-st6",
			d: "M86.87,56.42h14.06a1.8,1.8,0,0,1,1.79,1.8V69.91a1.8,1.8,0,0,1-1.79,1.79H86.87a1.79,1.79,0,0,1-1.79-1.79V58.22a1.8,1.8,0,0,1,1.79-1.8Z"
		})
	]
});
export default SvgCalendarCommon;
